import { initializeLogger } from '@b2x/shared';
import { buildTime, version } from './version';

const LOGGER_NAMESPACE = 'B2X@PL';

export const PL_LOG_GROUPS = {
  PAL: 'Pal',
  CONNECTION: 'PL Connection',
  LEGACY_CONNECTION: 'Legacy Connection',
  PROFILE: 'Profile',
  ONE_HEADER: 'One Header',
  NAVIGATION_ITEM: 'Navigation Item',
  NOTIFICATIONS: 'PL Notifications',
} as const;

type ExtendedLogGroups = typeof PL_LOG_GROUPS;

export const logger = initializeLogger<ExtendedLogGroups>(LOGGER_NAMESPACE, { buildTime, version });
